var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.87,
    height: 20,
    viewBox: "0 0 20.87 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2a3032;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.174,224A2.177,2.177,0,0,0,0,226.174v6.957A2.177,2.177,0,0,0,2.174,235.3H4.783a2.158,2.158,0,0,0,1.3-.44V224Z",
    transform: "translate(0 -224)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.58,22.624a1.928,1.928,0,0,0-.566-1.369,2.159,2.159,0,0,0,.557-1.66,2.248,2.248,0,0,0-2.268-1.971h-5.371a12.5,12.5,0,0,0,.692-3.478c0-1.886-1.6-3.478-2.609-3.478a2.735,2.735,0,0,0-1.576.53.437.437,0,0,0-.163.34v2.949l-2.5,5.425-.1.053v9.32a5.7,5.7,0,0,0,2.174.514h7.982a2,2,0,0,0,1.97-1.519,1.956,1.956,0,0,0-.157-1.306,1.948,1.948,0,0,0,.87-2.61A1.947,1.947,0,0,0,184.58,22.624Z",
    transform: "translate(-170.667 -10.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeInactive);
export default __webpack_public_path__ + "static/media/like_inactive.9b91349bbc44d03675a4637fd8d34da7.svg";
export { ForwardRef as ReactComponent };